export class LoginModel {
  public UserName: string;
  public Password: string;
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/models/login/login.model.ts